"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sleep = exports.isEmptyAddress = exports.remove0x = exports.pad0x = void 0;
function pad0x(str) {
    return str.startsWith('0x') ? str : `0x${str}`;
}
exports.pad0x = pad0x;
function remove0x(str) {
    return str.startsWith('0x') ? str.substring(2) : str;
}
exports.remove0x = remove0x;
function isEmptyAddress(address) {
    return !address || address === '0x' || address === '0x0' || address === '0x0000000000000000000000000000000000000000';
}
exports.isEmptyAddress = isEmptyAddress;
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
exports.sleep = sleep;
//# sourceMappingURL=common.js.map